'use client';

import useAlert from '@/hooks/useAlert';

// Tailwind toast replacing the MUI Alert; same useAlert()/AlertContext API, 2000ms auto-clear (handled in AlertContext).
const COLORS = {
  success: 'bg-emerald-600',
  error: 'bg-red-600',
  warning: 'bg-amber-600',
  info: 'bg-blue-600',
};

export default function AlertPopup() {
  const { text, type, clearAlert } = useAlert();

  if (!text || !type) return null;

  return (
    <div className="fixed right-4 top-4 z-[1400] flex justify-end px-4 pointer-events-none">
      <div className={`pointer-events-auto flex items-start gap-3 rounded-md px-4 py-3 text-sm font-medium text-white shadow-lg ${COLORS[type] || 'bg-gray-800'}`}>
        <span>{text}</span>
        <button
          type="button"
          onClick={clearAlert}
          aria-label="Close"
          className="-mr-1 -mt-0.5 shrink-0 rounded p-0.5 text-white/80 hover:text-white"
        >
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
